import React, { useState } from "react";
import Breadcrumb from "../../../../Components/Common/Breadcrumb";
import Tabs from "../../../../Components/Common/Tabs";
import { tutoringPagesTabsData } from "../../../../data/SidebarData";
import { useLocation } from "react-router-dom";
import useTable from "../../../../hooks/useTable";
import QueryString from "qs";
import useSWR from "swr";
import { orderUrls } from "../../../../Api/Auth/ApiUrls";
import Table from "../../../../Components/Common/Table";
import TableHead from "../../../../Components/Common/TableHead";
import { Loader } from "../../../../Components/Common/Loader";
import TutoringPurchaseRow from "./Components/TutoringPurchaseRow";
import NoData from "../../../../Components/Common/NoData";
import Pagination from "../../../../Components/Common/Pagination/Pagination";
import Modal from "../../../../Components/Common/Modal";
import TutoringPurchaseForm from "./Components/TutoringPurchaseForm";
import { sendPutRequestAuth } from "../../../../Api/swrConfig";
import useSWRMutation from "swr/mutation";
import { toast } from "react-toastify";
import useToastError from "../../../../hooks/useErrorToast";
import { useAuth } from "../../../../Context/AuthContext";
import { one2OneTutoring } from "../../../../Api/Auth/AppUrls";

const tableColumnData = [
  { id: "package", label: "Package" },
  { id: "amount", label: "Amount" },
  { id: "name", label: "User Name" },
  { id: "email", label: "User Email" },
  { id: "createdAt", label: "Purcahsed At" },
  { id: "packageStatus", label: "Status" },
];

const TutoringPurchase = () => {
  const { userData } = useAuth();
  const [row, setRow] = useState(null);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    packageStatus: "",
  });
  const [isModalOpen, setModalOpen] = useState(false);
  const { showErrorToast } = useToastError();

  const location = useLocation();
  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    useTable({ defaultOrderBy: "" });

  const handleInputChange = (name, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [name]: value, // Set only the field that's changed
    }));
  };

  const onEditClick = (row) => {
    setRow(row);
    handleInputChange("packageStatus", row.packageStatus);
    setModalOpen(true);
  };

  const apiQueryParams = {
    offset: (page - 1) * rowsPerPage,
    limit: rowsPerPage,
    type: "package",
  };
  const apiQueryString = QueryString.stringify(apiQueryParams);
  const { isLoading, data, mutate } = useSWR(orderUrls.list(apiQueryString));

  const { trigger, isMutating } = useSWRMutation(
    orderUrls.edit(row?._id),
    sendPutRequestAuth,
    {
      onSuccess: (data) => {
        toast.success("Success");
        mutate();
        setModalOpen(false);
      },
      onError: (error) => {
        showErrorToast(error);
      },
    }
  );

  const validateForm = () => {
    const newErrors = {};
    if (!formData.packageStatus) newErrors.packageStatus = "Status is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) return;
    const modifiedData = {
      ...formData,
      packageStatus:
        typeof formData.packageStatus === "object"
          ? formData.packageStatus.value
          : formData.packageStatus,
    };

    trigger(modifiedData);
  };

  return (
    <div>
      <Breadcrumb actionButtons={[]} />
      <Tabs
        tabs={
          userData?.roleId === 6
            ? tutoringPagesTabsData.filter(
                (item) => item.path !== one2OneTutoring.purchase
              )
            : tutoringPagesTabsData
        }
      />
      <Table>
        <TableHead rowCount={data?.data.length} headerData={tableColumnData} />
        <tbody className={`divide-y divide-gray-200`}>
          {!isLoading ? (
            <>
              {data?.data.map((row) => (
                <TutoringPurchaseRow
                  key={row._id}
                  row={row}
                  mutate={mutate}
                  onEditClick={onEditClick}
                />
              ))}
            </>
          ) : (
            <tr>
              <td colSpan="100" className="text-center py-4">
                <Loader />
              </td>
            </tr>
          )}
        </tbody>
        <NoData isNotFound={!data?.data.length && !isLoading} />
      </Table>
      <Pagination
        totalRows={data?.pagination.totalItems || 0}
        currentPage={page}
        rowsPerPage={rowsPerPage}
        currentPath={location.pathname}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <Modal
        isOpen={isModalOpen}
        title={"Edit tutoring status"}
        onConfirm={handleSubmit}
        onCancel={() => {
          setErrors({});
          setModalOpen(false);
        }}
        isLoading={isMutating}
        formWidth
      >
        <TutoringPurchaseForm
          errors={errors}
          handleSubmit={handleSubmit}
          onChange={handleInputChange}
          formData={formData}
        />
      </Modal>
    </div>
  );
};

export default TutoringPurchase;
